module.exports = __webpack_public_path__ + "img/cropper-example002.666ad967.png";